import React, { useState } from 'react';
import { useGetAllArtists } from '../../hooks/useGetAllArtists';
import {
  MenuItem,
  Box,
  Button,
  Typography,
  FormControl,
  SelectChangeEvent,
} from '@mui/material';
import SmallSelect from '../../components/Common/SmallSelect';
import { IconButton } from '@mui/material';
import { Edit } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { artistsState, paginationModelState } from '../../state/RecoilState';
import { useRecoilState, useRecoilValue } from 'recoil';
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import { Artist } from '../../@types/api';
import { artistStatus } from '../../Constants';

const Artists = () => {
  const navigate = useNavigate();
  const artists = useRecoilValue(artistsState);
  const [status, setStatus] = useState(11);
  const [paginationModel, setPaginationModel] =
    useRecoilState(paginationModelState);

  useGetAllArtists();

  const handleStatusChange = (event: SelectChangeEvent<unknown>) => {
    setStatus(Number(event.target.value));
  };

  const handleAddNewArtist = (event: React.MouseEvent<HTMLButtonElement>) => {
    navigate(`/artist/add`);
  };

  const handleEditArtist = (
    event: React.MouseEvent<HTMLButtonElement>,
    rowData: Artist
  ) => {
    navigate(`/artist/edit/${rowData.slug}`);
  };

  const mapped = (
    status > 0 ? artists.filter((x: Artist) => x.status === status) : artists
  ).map((x: Artist) => ({
    artistId: x.artistId,
    artistName: x.artistName,
    contactName: x.contactName,
    telephoneNumber: x.telephoneNumber,
    status: x.status,
    photo: x.photo,
    slug: x.slug,
  }));

  return (
    <Box>
      <Box my={1} display='flex' justifyContent={'space-between'}>
        <Typography variant='h5'>Artists</Typography>
        <Box>
          <Button
            variant='outlined'
            onClick={handleAddNewArtist}
            size='small'
            sx={{ mr: 1 }}
          >
            Add New Artist
          </Button>
          <FormControl size='small'>
            <SmallSelect
              labelId='demo-simple-select-label'
              id='demo-simple-select'
              value={status}
              onChange={handleStatusChange}
              variant='outlined'
              size='small'
            >
              <MenuItem value={artistStatus.LIVE}>Live</MenuItem>
              <MenuItem value={artistStatus.ADMINONLY}>Admin Only</MenuItem>
              <MenuItem value={artistStatus.REMOVED}>Removed</MenuItem>
            </SmallSelect>
          </FormControl>
        </Box>
      </Box>
      <DataGrid
        rows={mapped}
        getRowId={(row) => row.artistId}
        columns={
          [
            { headerName: 'ID', field: 'artistId', sortable: true, width: 50 },
            {
              field: 'actions',
              headerName: 'Actions',
              sortable: false,
              renderCell: (params) => (
                <div>
                  {!params.row.isFreeAction && (
                    <IconButton
                      onClick={(event) => handleEditArtist(event, params.row)}
                    >
                      <Edit />
                    </IconButton>
                  )}
                </div>
              ),
            },
            {
              headerName: 'Name',
              field: 'artistName',
              width: 200,
              sortComparator: (a, b) =>
                a.toLowerCase().localeCompare(b.toLowerCase()),
            },
            {
              headerName: 'Contact',
              field: 'contactName',
              width: 200,
              sortComparator: (a, b) =>
                a.toLowerCase().localeCompare(b.toLowerCase()),
            },
            {
              headerName: 'Telephone',
              field: 'telephoneNumber',
              width: 200,
              sortable: false,
            },
            {
              headerName: 'Image',
              field: 'photo',
              sortable: false,
              width: 400,
              renderCell: (params) => {
                if (!params.row.photo?.fileName) return null;
                return (
                  <Box
                    component='img'
                    sx={{ height: 50, p: '5px' }}
                    alt='artistImage'
                    src={`https://mfsresources.blob.core.windows.net/images/${params.row.photo.fileName}`}
                  />
                );
              },
            },
          ] as GridColDef[]
        }
        getRowHeight={() => 'auto'}
        pageSizeOptions={[25, 50, 100, 250]}
        paginationModel={paginationModel}
        onPaginationModelChange={setPaginationModel}
      />
    </Box>
  );
};
export default Artists;
